module.exports = __webpack_public_path__ + "assets/media/3.b4bc98cb.wav";